const extractIdFromGid = (gid) => gid && gid?.match(/[^/]+$/i)[0];

export default extractIdFromGid;
